import { Switch } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { ChangeEvent } from 'react';

export interface QuoteStatusCellProps<R extends GridValidRowModel = any, S = string, T extends S = S> {
  value: S;
  row: R;
  viewOnly?: boolean;
  onStatusToggle?: (rowId: string | number, newStatus: T) => void;
  checkedValue: T;
  uncheckedValue: T;
}

export const QuoteStatusCell = <R extends GridValidRowModel = any, S = string, T extends S = S>({
  value,
  row,
  viewOnly = true,
  onStatusToggle,
  checkedValue,
  uncheckedValue,
}: QuoteStatusCellProps<R, S, T>) => {
  const handleToggle = (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const newStatus = checked ? checkedValue : uncheckedValue;
    onStatusToggle?.(row.id, newStatus);
  };

  const checked = value !== uncheckedValue;
  return <Switch checked={checked} onChange={handleToggle} disabled={viewOnly} />;
};
